export default __webpack_public_path__ + "static/media/arrowLeft.beb4f89c.webp";